import Offers from './offers';
import Orders from './orders';
import Auth from './auth';

export default {
  Orders,
  Offers,
  Auth,
};
